/**
 * Common weak passwords that should be rejected
 * This list can be extended as needed
 */
export const COMMON_WEAK_PASSWORDS = [
	'password',
	'123456',
	'qwerty',
	'abc123',
	'password123',
	'12345678',
	'iloveyou',
	'princess',
	'rockyou',
	'1234567',
	'1234567890',
	'letmein',
	'trustno1',
	'dragon',
	'baseball',
	'monkey',
	'sunshine',
	'master',
	'admin',
	'welcome',
] as const;

/**
 * Checks if a password is in the list of common weak passwords
 * @param password - The password to check
 * @returns true if the password is weak, false otherwise
 */
export const isWeakPassword = (password: string): boolean => {
	if (!password) return false;
	const lowerCasePassword = password.toLowerCase();
	return COMMON_WEAK_PASSWORDS.some(weakPassword => lowerCasePassword === weakPassword);
};

